// Libraries
import React, { useState } from 'react';

//Material-UI
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const AlertContext = React.createContext();

const AlertBar = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    open: false,
    severity: 'info',
    message: '',
    duration: 5000
  });

  const handleAlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlert({ ...alert, open: false });
  };

  const throwAlert = (message, severity, duration) => {
    setAlert({
      ...alert,
      open: true,
      message,
      severity: severity || 'info',
      duration: duration || 5000
    });
  };

  return (
    <AlertContext.Provider value={{ throwAlert }}>
      {children}
      <Snackbar open={alert.open} autoHideDuration={alert.duration} onClose={handleAlertClose}>
        <AlertBar onClose={handleAlertClose} severity={alert.severity}>
          {alert.message}
        </AlertBar>
      </Snackbar>
    </AlertContext.Provider>
  );
};

export default AlertContext;
export { AlertProvider };
